import { validateAttrStatus,validateAttrStatusGroup } from "./CommonUtils";
import { CREATE } from "./Constants";
import { findInObjectById } from "./SchemaParseUtils";

// Check if the provided attribute is mandatory and is not empty
export const validateMandatory = (isMandatory, value) => {

    return isMandatory ? (isMandatory && (value !== "" && value !== undefined)) : true
}

// Check if all mandatory attributes are true
export const validateAllMandatoryAttr = (obj, srcObj=null) => { // Todo: Optimization required
    for (const key in obj) {
        if (typeof obj[key] === 'object') {
            // Recursive call for nested objects
            if (!validateAllMandatoryAttr(obj[key], srcObj)) return false;
        } else if(obj.id) {
            // Check if value is true and non-empty
            if ((!obj.link || (obj.link && obj.visible)) && !validateAttrStatus(obj)) 
                return false;
            else {
                if((srcObj && obj.isModified)) { // TBC: Required ?
                    const exObj = findInObjectById(srcObj, obj.id)
                    obj = {
                        ...obj,
                        isModified: exObj.value === obj.value ? false : true
                    }
                }
            }
        }
    }

    return obj // Return the obj if validation succeed
}

export const validateAllMandatoryAttrGroup = async (obj, srcObj = null) => {

  // 1. Traverse children first
  for (const key in obj) {
    const item = obj[key]

    if (typeof item === "object" && item !== null) {
      const nested = await validateAllMandatoryAttrGroup(item, srcObj)
      if (nested === false) return false
    }
  }
  // 2. Now validate THIS object only once
  if (obj?.id) {
    if (!obj.link || (obj.link && obj.visible)) {
      const isValid = await validateAttrStatusGroup(obj, srcObj)
      if (!isValid) return false
    }
    else {
      if (srcObj && obj.isModified) {
        const exObj = findInObjectById(srcObj, obj.id)
        obj.isModified = exObj.value === obj.value ? false : true
      }
    }
  }
  return obj;
};

// Validation check for selected attributes
export const validateSelectedMandatoryAttrs = (obj, arr = [], srcObj = null) => {
    if (Array.isArray(obj)) {
      for (const item of obj) {
        const result = validateSelectedMandatoryAttrs(item, arr, srcObj)
        if (!result) return false
      }
    } else if (typeof obj === 'object' && obj !== null) {
      // Check if this object has an ID that matches and has attributes
      if (obj.id && arr.includes(obj.id) && Array.isArray(obj.attribute)) {
        for (const attr of obj.attribute) {
          if ((!attr.link || (attr.link && attr.visible)) && !validateAttrStatus(attr)) {
            return false
          }
  
          if (srcObj && attr.isModified) {
            const exObj = findInObjectById(srcObj, attr.id)
            attr.isModified = exObj?.value !== attr.value
          }
        }
      }
  
      // Recursively check all keys in the object
      for (const key in obj) {
        const result = validateSelectedMandatoryAttrs(obj[key], arr, srcObj)
        if (!result) return false
      }
    }
  
    return true
  }

// Check Read-only access of an attribute field
export const applyROAccess = (access, actionMode = "") => {
    switch (access) {
        case "WCREATE_RUPDATE":
            return actionMode === CREATE ? false : true
        case "RCREATE_WUPDATE":
            return actionMode === CREATE ? true : false
        case "READWRITE":
            return false
        case "READONLY":
            return true
        default:
            return false // default READWRITE
    }
}